export default "__VITE_ASSET__KbyK0mP___"